import React,{useState} from 'react';
const {friendlyPickReason}=require('./friendlyPickReason');
const {selectionLabel}=require('./customerBoardPresentation');
import SavedGridEvidence from './SavedGridEvidence';
// Claude prototype: five columns, two rows, large zero-preserving digit strings.
// Selection is a local review list; it never changes the issued board.
export default function DailyNumberTiles({candidates,strategy,gridEvidence}){
 const [selected,setSelected]=useState([]);
 const sample=strategy==='grid'?candidates.find(p=>require('./gridExplanation').gridVisualEvidence(p,p.gridEvidence??gridEvidence)):null;
 return <div className={"daily-number-tiles picks-"+strategy}>
  <div className="daily-number-grid">{candidates.map(p=><button type="button" key={p.family} className={selected.includes(p.straight)?'daily-number selected':'daily-number'} aria-pressed={selected.includes(p.straight)} aria-label={'Select '+p.straight} onClick={()=>setSelected(v=>v.includes(p.straight)?v.filter(n=>n!==p.straight):[...v,p.straight])}><strong>{p.straight}</strong><span>{selectionLabel(p.selectionTier)}</span></button>)}</div>
  {selected.length>0&&<p>Review list: {selected.join(' · ')}</p>}
  <details><summary>Why These Numbers?</summary><p>{friendlyPickReason(sample||candidates[0],strategy)}</p>{sample&&<SavedGridEvidence pick={sample} stored={gridEvidence} expanded/>}</details>
 </div>;
}


